import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-200">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-base font-bold text-background-50">
                看
              </span>
              <span className="font-heading text-xl font-bold text-background-50">看料88</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              专注娱乐话题回顾的存档型内容站。我们把综艺、影视、创作者与网络热议按时间线归档，让旧料可以随时被翻出来重看。
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line text-accent-400" />
              <a href="mailto:hello@kanliao88.example.com" className="hover:text-accent-300">
                hello@kanliao88.example.com
              </a>
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50">站内导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/archive" className="text-background-300 transition-colors hover:text-accent-300">
                  往期存档
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background-300 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50">内容分类</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/archive?cat=${cat.key}`}
                    className="text-background-300 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-heading text-sm font-semibold text-background-50">订阅更新 / 提供线索</h4>
            <p className="mt-2 text-xs leading-relaxed text-background-400">
              留下邮箱，新存档上线时第一时间通知你。
            </p>
            <div className="mt-4">
              <SubscribeForm tone="dark" />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 看料88 · 往期娱乐热料存档</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>内容基于公开信息整理，仅供话题回顾与讨论</span>
            <Link to="/faq" className="text-background-300 hover:text-accent-300">
              内容原则与版权说明
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}